<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Identity verification</mat-card-title>
    <button *ngIf="canEditManually"
            mat-icon-button
            routerLink="/customer/{{customerId}}/identity-verification"
            aria-label="Edit"
            matTooltip="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="verificationStatusValue">
        <div class="status-container">
          <ifc-status-label
            [status]="VerificationStatusLabels"
            [value]="identityVerification?.status"
          ></ifc-status-label>
        </div>
      </ng-template>

      <ng-template horizontalListCustomTemplate="startKbaActionItem">
        <div class="action">
          <a class="action__text" (click)="onStartKbaVerification()"
            >Start KBA verification</a
          >
          <button
            mat-icon-button
            matTooltip="Start KBA verification"
            class="action__button"
            (click)="onStartKbaVerification()"
          >
            <mat-icon class="action__icon">send</mat-icon>
          </button>
        </div>
      </ng-template>

      <ng-template horizontalListCustomTemplate="startNewIdVerseActionItem">
        <div class="action">
          <a class="action__text" (click)="onStartNewIdVerseVerification()"
            >Start new IDVerse verification</a
          >
          <button
            mat-icon-button
            matTooltip="Start new IDVerse verification"
            class="action__button"
            (click)="onStartNewIdVerseVerification()"
          >
            <mat-icon class="action__icon">send</mat-icon>
          </button>
        </div>
      </ng-template>

      <ng-template horizontalListCustomTemplate="setToVerifiedActionItem">
        <div class="action">
          <a class="action__text" (click)="onSetToVerified()"
            >Set status to 'Verified'</a
          >
          <button
            mat-icon-button
            matTooltip="Set status to 'Verified'"
            class="action__button"
            (click)="onSetToVerified()"
          >
            <mat-icon class="action__icon">send</mat-icon>
          </button>
        </div>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
